import { AfterViewInit, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { properties } from '../../../../environments/properties';
import { SubscriptionService } from "../../../shared/services/subscription.service";

declare let $: any;
declare let AB: any;

@Component({
  selector: 'app-current-plan',
  templateUrl: './current-plan.component.html',
  styleUrls: ['./current-plan.component.scss']
})
export class CurrentPlanComponent implements AfterViewInit {

  @Input() userSubscriptionDetails: any;
  @Input() userInfo: any;
  @Input() tenderInfo;
  @Input() currentEnvironment;
  @Input() showTenders;

  subscriptionType: any;
  hasPendingSubscription: any;
  pricingDetail: any;
  subSummaryTitle: string = '';
  showChangePlanLink = false;
  showCanNotChangePlanText = false;

  properties = properties;

  snapFlagEnabled: boolean = properties.featureFlags.enableSnap;
  isSnapPlan: boolean = false;
  SNAP_KEY: string = properties.freshpassData.snapKey;
  pleaseReverifyEligibilityText: string = properties.freshpassData.pleaseReverifyEligibilityText;
  govAssistanceElibilityText: string = properties.freshpassData.govAssistanceElibilityText;
  freeTrialTitle: string = properties.freshpassData.freeTrialTitle;
  showCancelFpPlanLink: boolean = true;

  constructor(
    private router: Router,
    public subscriptionService: SubscriptionService,
  ) {
  }

  ngOnInit() {
    if (this.userSubscriptionDetails) {
      this.hasPendingSubscription = this.userSubscriptionDetails.pendingSubscriptionType ? true : false;
    }
  }

  ngAfterViewInit(): void {
    if (this.userSubscriptionDetails) {
      this.isSnapPlan = this.userSubscriptionDetails?.discountType?.toLowerCase().includes(this.SNAP_KEY)
    }
    let isTrialPlan = false;
    isTrialPlan = this.getTrialPlanStatus(this.userSubscriptionDetails);
    this.setSubSummaryTitle(this.userSubscriptionDetails);
    this.setSubscriptionTypeText(this.userSubscriptionDetails);
    this.setSubscriptionCostText(this.userSubscriptionDetails);

    if (this.userSubscriptionDetails.subscriptionStatus === this.properties.manage.PENDING_CANCELLATION) {
      $('#subscription-enddate').html(this.properties.manage.ENDS + ' ' + this.subscriptionService.convertDate(this.userSubscriptionDetails.curentPlanExpiryDate));
    } else {
      if (isTrialPlan) {
        $('#subscription-enddate').html(this.userSubscriptionDetails.subscriptionType + " " + this.properties.manage.BEGINS + " " + this.subscriptionService.convertDate(this.userSubscriptionDetails.renewalDate));
      } else {
        $('#subscription-enddate').html(this.properties.manage.RENEWS + ' ' + this.subscriptionService.convertDate(this.userSubscriptionDetails.renewalDate));
      }
      this.checkAndUpdateRetentionSubscriptinEndDateMessage();
    }
    //Backend change plan flag for displaying change plan link
    this.showChangePlanLink = this.userSubscriptionDetails.isPlanChangeAvailable;

    if (this.userSubscriptionDetails.subscriptionStatus === this.properties.manage.SUSPENDED.toUpperCase() 
      || ((this.userSubscriptionDetails.subscriptionStatus === this.properties.manage.PENDING_ACTIVATION) && (this.userSubscriptionDetails.status === this.properties.manage.SUSPENDED))) {
      $('#subscription-enddate').hide()
    }

    if ((this.userSubscriptionDetails.subscriptionStatus === this.properties.manage.PENDING_ACTIVATION) && (this.userSubscriptionDetails.status != this.properties.manage.SUSPENDED)) {
      if (this.userSubscriptionDetails.pendingRenewalDate && this.userSubscriptionDetails.pendingFee && this.userSubscriptionDetails.pendingSubsCode) {
        let planType ="";
        const addDiscountLabel = this.getDiscountLabel();
        if (this.userSubscriptionDetails.pendingSubsCode === 'F9B88F7E-5F54-4536-AFC0-8B080D189CDF') {
          planType = properties.manage.MONTHLY;
        } else {
          planType = properties.manage.ANNUAL;
        }
        planType = addDiscountLabel ? planType.toLowerCase() : planType;
        if (addDiscountLabel) {
          $('#subscription-enddate').html(addDiscountLabel + planType + " " + this.properties.manage.PLAN_BEGINS + "</br>" + this.subscriptionService.convertDate(this.userSubscriptionDetails.renewalDate));
        } else {
          $('#subscription-enddate').html(planType + " " + this.properties.manage.PLAN_BEGINS + " " + this.subscriptionService.convertDate(this.userSubscriptionDetails.renewalDate));
        }
      }
    }
    if (this.userSubscriptionDetails.subscriptionStatus === this.properties.manage.PROCESSING) {
      if (this.userSubscriptionDetails.renewalDate && this.userSubscriptionDetails.fee && this.userSubscriptionDetails.subscriptionCode) {
        let planType;
        if (this.userSubscriptionDetails.subscriptionCode === 'F9B88F7E-5F54-4536-AFC0-8B080D189CDF') {
          planType = properties.manage.MONTHLY;
        } else {
          planType = properties.manage.ANNUAL;
        }
        $('#subscription-enddate').html(planType + " " + this.properties.manage.PLAN_BEGINS + " " + this.subscriptionService.convertDate(this.userSubscriptionDetails.renewalDate));
      }
    }

    if (this.userSubscriptionDetails.subscriptionStatus === this.properties.manage.CHANGE_PLAN_CON) {
      this.showCanNotChangePlanText = true;
    }

    if (this.userSubscriptionDetails.subscriptionStatus === this.properties.manage.PENDING_CANCELLATION
      || this.userSubscriptionDetails.subscriptionStatus === this.properties.manage.CANCELLED) {
      this.showCancelFpPlanLink = false;
    }
  }

  checkAndUpdateRetentionSubscriptinEndDateMessage() {
    if (this.userSubscriptionDetails?.pendingDiscountType?.toLowerCase() === this.properties.prechurn.retentionDiscountType) {
      $("subscription-enddate").html(this.properties.prechurn.discountPlanBeginsMessage.replace('{pendingSubscriptionType}', this.userSubscriptionDetails.pendingSubscriptionType.toLowerCase()).replace('{renewalDate}', this.subscriptionService.convertDate(this.userSubscriptionDetails.renewalDate)));
    }
  }
  getDiscountLabel() {
    const isPendingRetentionDiscount = this.userSubscriptionDetails?.pendingDiscountType?.toLowerCase() === this.properties.prechurn.retentionDiscountType;
    return isPendingRetentionDiscount ? 'Discounted ' : '';
  }
  
  getTrialPlanStatus(data) {
    if (data) {
      if ((data.status.toLowerCase() === this.properties.manage.TRIAL.toLowerCase()) || (data.status.toLowerCase() === this.properties.manage.PROCESSING.toLowerCase() && data.previousStatus && data.previousStatus.toLowerCase() === this.properties.manage.TRIAL.toLowerCase())) {
        return true;
      }
    }

    return false;
  }

  goToChangePlan() {
    this.router.navigate(['freshpass/manage/change'], { state: { userSubscriptionDetails: this.userSubscriptionDetails, isRedirectedFromManageLink: true } });
    if (window['AB'] && window['AB']['DATALAYER']) {
      window['AB'].DATALAYER.analyticsSetLSFPUpdate('upgradeBtn', this.userSubscriptionDetails.subscriptionStatus);
      window['AB']['DATALAYER'].updateAnalyticsSubscriptionInfo('change', {});
    }
  }

  setSubSummaryTitle(data) {
    const subscriptionType = data.subscriptionType;
    const isTrialPlan = this.subscriptionService.getTrialPlanStatus(data)

    if (isTrialPlan) {
      if (this.isSnapPlan) {
        this.subSummaryTitle = subscriptionType;
      } else {
        this.subSummaryTitle = this.freeTrialTitle;
      }
      $('#freetrial-enddate').html(this.properties.manage.FREE_TRIAL_ENDS_ON + ' ' + this.subscriptionService.convertDate(data.curentPlanExpiryDate) + '.');
    } else {
      $('#freetrial-enddate').html('');
      this.subSummaryTitle = subscriptionType;
    }
  }

  setSubscriptionTypeText(data) {
    let isTrialPlan = this.subscriptionService.getTrialPlanStatus(data)
    if (isTrialPlan) {
      $('#subscription-type-freshPass').html('<span>' + this.properties.manage.FREE_TRIAL + '</span>');
    } else if (data.subscriptionType.toLowerCase().indexOf(this.properties.manage.MONTHLY.toLowerCase()) >= 0) {
      $('#subscription-type-freshPass').html('<span>' + this.properties.manage.MONTHLY_SUBSCRIBER + '</span>');
    } else {
      $('#subscription-type-freshPass').html('<span>' + this.properties.manage.ANNUAL_SUBSCRIBER + '</span>');
    }
  }

  setPendingCostDetails(data, currentPrice) {
    if (this.userSubscriptionDetails.subscriptionStatus !== this.properties.manage.PENDING_CANCELLATION){
      let pendingPricingDetail = this.subscriptionService.getPricingDetail(data.pendingPricingDetail, data.subscriptionType);
      let isMonthlyPlan = (data.subscriptionType.toLowerCase().indexOf(this.properties.manage.MONTHLY.toLowerCase()) >= 0) ? true : false;
      let isTrial = (data.status.toLowerCase() === this.properties.manage.TRIAL.toLowerCase() || data.subscriptionStatus === this.properties.manage.TRIAL) ? true : false;
      let planType = isMonthlyPlan ? this.properties.manage.PLAN_PER_MONTH : this.properties.manage.PLAN_PER_YEAR;
  
      if (isTrial) {
        if (data.pendingDiscountType?.toLowerCase() === this.properties.prechurn.retentionDiscountType && data.pendingFee && data.pendingPricingDetail) {
          $('#subscription-type').html('');
          $('#renewal-cost-text').html(this.properties.manage.AUTO_RENEWS_AT_PENDING_FEE.replace('{pendingFee}', data.pendingFee).replace('{pendingPricingDetails}', data.pendingPricingDetail));
        } else {
          $('#subscription-type').html('');
          $('#renewal-cost-text').html(this.properties.manage.AUTO_RENEWS_AT + data.pendingFee + pendingPricingDetail + ' ' + this.properties.manage.TAX + '.');
        }
      } else {
        $('#subscription-type').html('$' + currentPrice + planType + " " + this.properties.manage.UNTIL + " " + this.subscriptionService.convertDate((data.curentPlanExpiryDate)) + ' ' + this.properties.manage.TAX + '.');
        $('#renewal-cost-text').html(this.properties.manage.AUTO_RENEWS_AT + data.pendingFee + pendingPricingDetail + '.');
      }
    }
  }

  setSubscriptionCostText(data) {
    const isTrialStatus = this.getTrialPlanStatus(data);
    let pricingDetail = this.subscriptionService.getPricingDetail(data.pricingDetail, data.subscriptionType);
    let isPendingAnnualPlan = (data?.pendingSubscriptionType === this.properties.manage.ANNUAL_PLAN) ? true : false;
    let isPendingMonthlyPlan = (data?.pendingSubscriptionType === this.properties.manage.MONTHLY_PLAN) ? true : false;
    let isMonthlyPlan = (data.subscriptionType.toLowerCase().indexOf(this.properties.manage.MONTHLY.toLowerCase()) >= 0) ? true : false;
    let currentPrice = data.fee;
    let planType = isMonthlyPlan ? this.properties.manage.PLAN_PER_MONTH : this.properties.manage.PLAN_PER_YEAR;
    let isSnapUser = data.discountType && data.discountType.toLowerCase().includes(this.SNAP_KEY) ? true : false;


    //backend response data.isDiscountedPrice is set true for all promotion plans (oneplan, no-freetrial) even when not actually discounted 
    let isDiscountedPriceAndEndDate = (data.isDiscountedPrice && data.discountEndDate) ? true : false;
    //checks to see if the plan is actually discounted
    let isDiscountedPrice = parseFloat(data.fee) !== data.regularPlanPrice;

    if (currentPrice.indexOf(' / ') >= 0) {
      currentPrice.replace(' / ', '/');
    }
    //enrolled in Monthly plan
    if (isMonthlyPlan) {
      if (isDiscountedPrice) {
        if (isPendingAnnualPlan && data.pendingFee && data.pendingPricingDetail && data.pendingRenewalDate) {
          this.setPendingCostDetails(data, currentPrice);
        } else {
          if (isSnapUser) {
            $('#subscription-type').html('');
            $('#renewal-cost-text').html(this.properties.manage.AUTO_RENEWS_AT + data.fee + this.properties.manage.PLAN_PER_MONTH + ' ' + this.properties.manage.TAX + '.');
          } else if (isDiscountedPriceAndEndDate) {
            $('#renewal-cost-text').html(this.properties.manage.AUTO_RENEWS_AT + data.regularPlanPrice + this.properties.manage.PLAN_PER_MONTH + ".");
            $('#subscription-type').html('$' + currentPrice + planType + " " + this.properties.manage.UNTIL + " " + this.subscriptionService.convertDate(data.discountEndDate) + ' ' + this.properties.manage.TAX + '.');
          } else {
            $('#subscription-type').html('');
            $('#renewal-cost-text').html(this.properties.manage.AUTO_RENEWS_AT + data.regularPlanPrice + this.properties.manage.PLAN_PER_MONTH + ".");
          }
        }
      } else {
        if (isPendingAnnualPlan && data.pendingFee && data.pendingPricingDetail && data.pendingRenewalDate) {
          this.setPendingCostDetails(data, currentPrice);
        } else {
          $('#subscription-type').html('');
          $('#renewal-cost-text').html(this.properties.manage.AUTO_RENEWS_AT + currentPrice + this.properties.manage.PLAN_PER_MONTH + " " + this.properties.manage.TAX + '.');
        }
      }
      // if the user has just become sheer verified, the new pricing will come as part of pending fee with no pendingSubType
      if (this.snapFlagEnabled && data.isSheerVerified && data.pendingFee) {
        let pendingDetails = data.pendingPricingDetail ? data.pendingPricingDetail : data.pricingDetail;
        $('#subscription-type').html('');
        //Monthly renewal cost text comes as: Auto-renews at $5.99/month(+tax)
        $('#renewal-cost-text').html(this.properties.manage.AUTO_RENEWS_AT + data.pendingFee + pendingDetails + ' ' + this.properties.manage.TAX + '.');
      }
    } else {
      //currently enrolled in Annual Plan
      if (isDiscountedPriceAndEndDate && isDiscountedPrice) {
        if (isPendingMonthlyPlan && data.pendingFee && data.pendingPricingDetail && data.pendingRenewalDate) {
          this.setPendingCostDetails(data, currentPrice);
        }
        else if (isSnapUser) {
          $('#subscription-type').html('');
          $('#renewal-cost-text').html(this.properties.manage.AUTO_RENEWS_AT + data.fee + this.properties.manage.PLAN_PER_YEAR + " " + this.properties.manage.TAX + '.');
        }
        else {
          $('#subscription-type').html('$' + currentPrice + pricingDetail + ' ' + this.properties.manage.TAX + '.');
          $('#renewal-cost-text').html(this.properties.manage.AUTO_RENEWS_AT + data.regularPlanPrice + this.properties.manage.PLAN_PER_YEAR + ".");
        }
      } else {
        if ((isPendingMonthlyPlan && data.pendingFee && data.pendingPricingDetail && data.pendingRenewalDate) || 
              (isPendingAnnualPlan && data.pendingFee && data.pendingPricingDetail && data.pendingRenewalDate)) {
          this.setPendingCostDetails(data, currentPrice);
        } else {
          $('#subscription-type').html('');
          $('#renewal-cost-text').html(this.properties.manage.AUTO_RENEWS_AT + data.regularPlanPrice + this.properties.manage.PLAN_PER_YEAR + " " + this.properties.manage.TAX + '.')
        }
      }
      // if the user has just become sheer verified, the new pricing will come as part of pending fee
      if (this.snapFlagEnabled && data.isSheerVerified && data.pendingFee) {
        let pendingDetails = data.pendingPricingDetail ? data.pendingPricingDetail : data.pricingDetail;
        $('#subscription-type').html('');
        //Annual sheer verification text comes as: Auto-renews at $49/year(+tax)
        if (pendingDetails.includes(properties.freshpassData.forTheFirstYearText)) {
          $('#renewal-cost-text').html('Auto-renews at $' + data.pendingFee + ' ' + pendingDetails + ' (+tax).');
        } else {
          $('#renewal-cost-text').html('Auto-renews at $' + data.pendingFee + pendingDetails + ' (+tax).');
        }
      }
    }
    if (data.subscriptionStatus === this.properties.manage.PENDING_CANCELLATION || data.subscriptionStatus === this.properties.manage.CANCELLED || data.subscriptionStatus === this.properties.manage.SUSPENDED.toUpperCase()) {
      $('#renewal-cost-text').html('')
      if (isTrialStatus) {
        $('#subscription-type').html('');
      } else {
        if (isDiscountedPriceAndEndDate) {
          $('#subscription-type').html('$' + currentPrice + planType + " " + this.properties.manage.UNTIL + " " + this.subscriptionService.convertDate(data.curentPlanExpiryDate) + ' ' + this.properties.manage.TAX + '.');
        } else {
          $('#subscription-type').html('$' + currentPrice + pricingDetail + ' ' + this.properties.manage.TAX + '.');
        }
      }
      if (data.subscriptionStatus === this.properties.manage.SUSPENDED.toUpperCase() && data.isPromoExpired && data.promoInfo.includes(this.govAssistanceElibilityText)) {
        $('#subscription-type').html(this.pleaseReverifyEligibilityText);
      }
    }
  }

  goToCancelPlan() {
    this.router.navigate(['/freshpass/manage/cancel-plan'], { state: { userSubscriptionDetails: this.userSubscriptionDetails } });
  }
}
